import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=5e0de353"
import script from "./Chapter.vue?vue&type=script&lang=js"
export * from "./Chapter.vue?vue&type=script&lang=js"
import style0 from "./Chapter.vue?vue&type=style&index=0&id=5e0de353&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports